module.exports = __webpack_public_path__ + "static/media/draft-beer.018316b8.png";